export enum ExecutionLabType {
  TestsigmaLab = 'TestsigmaLab',
  Hybrid = 'Hybrid',
  SauceLabs = 'SauceLabs',
  BrowserStack = 'BrowserStack',
  LambdaTest = 'LambdaTest',
  Kobiton = 'Kobiton',
  PrivateGrid = 'PrivateGrid',
}
